import { Tabs as LsTabs, Tab as LsTab } from 'components/common/Tabs'
import styled from '@emotion/styled'
import Box from '@mui/material/Box'

const StyledTabs = styled(LsTabs)`
  ${({ theme }) => `
    & .MuiTabs-indicatorSpan {
      position: absolute,
      max-width: 32px;
      width: 32px !important;
      border-radius: 2px;
      background: ${theme.palette.primary.main};
    }
  `}
`

export const StickyTabsWrapper = styled(Box)`
  ${({ theme }) => `
    position: sticky;
    top: 0;
    z-index: 8;
    background-color: white;
    margin-bottom: 24px;

    ${theme.breakpoints.up('lg')} {
      margin-bottom: 32px;
    }
  `}
`

export const Tabs = (props) => {
  return (
    <StyledTabs
      {...props}
      variant="scrollable"
      scrollButtons="auto"
      textColor="primary"
      TabIndicatorProps={{
        children: <span className="MuiTabs-indicatorSpan" />,
        sx: {
          display: 'flex',
          justifyContent: 'center',
          background: 'transparent',
          marginBottom: '4px',
        },
      }}
    />
  )
}

export const StyledTab = styled(LsTab)`
  ${({ theme }) => `
    &.MuiTab-root {
      width: auto;
      font-size: ${theme.typography.subtitle3.fontSize};
      font-weight: 700;
      padding: ${theme.spacing(0)};
      white-space: nowrap;
      align-items: flex-start;

      &:not(:first-child) {
        margin-left: 24px;
      }
    }
  `}
`

export const Tab = (props) => {
  return <StyledTab {...props} disableTouchRipple />
}
